<template lang="pug">
#RevisarCotizacion
  b-button(
    variant="action"
    @click="goToRevisarCotizacion()"
  )
    | Revisar Cotización
</template>
<script>
export default {
  name: 'RevisarCotizacion',
  props: {
    dataOv: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToRevisarCotizacion() {
      this.$router.push(
        `/oportunidad-venta/${this.dataOv.id}/revisar-cotizacion`
      )
    },
  },
}
</script>
